import React from 'react';
import AboutUs from './components/AboutComponent';

const AboutApp = () => <AboutUs />;

export default AboutApp;
